import { render } from "./EmployeeDiscountForm.vue?vue&type=template&id=2690c29c"
import script from "./EmployeeDiscountForm.vue?vue&type=script&lang=js"
export * from "./EmployeeDiscountForm.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__